import { AnimatePresence } from 'framer-motion';
import {
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
// pages
import Home from '../pages/Home/Dashboards';

import Triangulation from '../pages/Triangulation';

import useGetGeneralAppData from '../hooks/useGetGeneralAppData';
import Dashboard from '../pages/Affreightments/Dashboard';
import Lines from '../pages/Affreightments/Lines';
import LineMap from '../pages/Affreightments/Lines/Map';
import Passengers from '../pages/Affreightments/Passengers';
import Vehicles from '../pages/Affreightments/Vehicles';
import EditVehicle from '../pages/Affreightments/Vehicles/EditVehicle';
import NewVehicle from '../pages/Affreightments/Vehicles/NewVehicle';
// import AutImplantation from '../pages/AutImplantation';
import { useAppContext } from '../contexts/auth';
import ChangePassword from '../pages/ChangePassword';
import ClientUsers from '../pages/ClientUsers';
import EditClientUser from '../pages/ClientUsers/EditInternalUser';
import NewClientUser from '../pages/ClientUsers/NewClientUser';
import Company from '../pages/Company';
import Branches from '../pages/Company/Branches';
import NewBranch from '../pages/Company/Branches/NewBranch';
import Settings from '../pages/Company/Settings';
import ConsultResult from '../pages/Consults/ConsultResult';
import ImportConsults from '../pages/Consults/ImportConsults';
import NewConsult from '../pages/Consults/NewConsult';
import SearchConsult from '../pages/Consults/SearchConsult';
// import ImportVtRegistrationData from '../pages/ImportVtRegistrationData';
import ItensRelations from '../pages/ItensRelations';
import NotFound from '../pages/NotFound';
import ReclamationsAtPeriod from '../pages/ReclamationsAtPeriod';
import Workplaces from '../pages/Workplaces';
import EditWorkplace from '../pages/Workplaces/EditWorkplace';
import NewWorkplace from '../pages/Workplaces/NewWorkplace';

export default function AllRoutes() {
  const location = useLocation();
  const { permissions, services } = useGetGeneralAppData();

  const companyPermissions = permissions.find((x) => x.codPag === 1);
  const companySettingsPermissions = permissions.find((x) => x.codPag === 2);
  const clientUsersPermissions = permissions.find((x) => x.codPag === 3);
  const workplacesPermissions = permissions.find((x) => x.codPag === 4);
  // const autImplantationPermissions = permissions.find((x) => x.codPag === 5);
  const routingPermissions = permissions.find((x) => x.codPag === 6);
  const routingFilePermissions = permissions.find((x) => x.codPag === 7);
  const reclamationsPermissions = permissions.find((x) => x.codPag === 8);
  const affreightmentsDashboardPermissions = permissions.find((x) => x.codPag === 9);
  const affreightmentsLinesPermissions = permissions.find((x) => x.codPag === 10);
  const affreightmentsVehiclesPermissions = permissions.find((x) => x.codPag === 11);
  const affreightmentsPassengersPermissions = permissions.find((x) => x.codPag === 12);
  const triangulationPermissions = permissions.find((x) => x.codPag === 13);

  const routingServicesCode = [12, 2, 3, 15, 10, 11];
  const hasSomeRoutingService = !services || services.some((service) => routingServicesCode.includes(service.codServ));
  // const hasAutImplantationService = !services || services.some((service) => service.codServ === 18);
  const hasAffreightmentsService = !services || services.some((service) => service.codServ === 14);
  const hasAffreightmentsAccessControlService = !services || services.some((service) => service.codServ === 16);
  const hasTriangulationService = !services || services.some((service) => service.codServ === 17);

  const { isDirectLogin } = useAppContext();

  return (
    <AnimatePresence mode="wait">
      <Routes
        location={location}
        key={location.pathname}
      >
        <Route path="/" element={<Home activeSidebar="Home" />} />

        {!isDirectLogin && (
          <Route path="/changePassword" element={<ChangePassword />} />
        )}

        {(clientUsersPermissions && clientUsersPermissions.vizualizar) && (
          <>
            <Route path="/clientUsers" element={<ClientUsers />} />
            {clientUsersPermissions.incluir && (
              <Route path="/clientUsers/new" element={<NewClientUser />} />
            )}
            {clientUsersPermissions.alterar && (
              <Route path="/clientUsers/:id" element={<EditClientUser />} />
            )}
          </>
        )}

        {(companyPermissions && companyPermissions.vizualizar) && (
          <>
            <Route path="/company" element={<Company />} />
            {companySettingsPermissions && companySettingsPermissions.vizualizar && (
              <Route path="/company/settings" element={<Settings />} />
            )}
            <Route path="/company/branches" element={<Branches />} />
            <Route path="/company/branches/new" element={<NewBranch />} />
          </>
        )}

        {workplacesPermissions && workplacesPermissions.vizualizar && (
          <>
            <Route path="/workplaces" element={<Workplaces />} />
            {workplacesPermissions.incluir && (
              <Route path="/workplaces/new" element={<NewWorkplace />} />
            )}
            {workplacesPermissions.alterar && (
              <Route path="/workplaces/:workplaceId" element={<EditWorkplace />} />
            )}
          </>
        )}

        {(affreightmentsLinesPermissions && affreightmentsLinesPermissions.vizualizar && hasAffreightmentsService) && (
          <>
            <Route path="/lines" element={<Lines />} />
            <Route path="/lines/map" element={<LineMap />} />
          </>
        )}

        {(affreightmentsVehiclesPermissions && affreightmentsVehiclesPermissions.vizualizar && hasAffreightmentsAccessControlService) && (
          <>
            <Route path="/vehicles" element={<Vehicles />} />
            {affreightmentsVehiclesPermissions.incluir && (
              <Route path="/vehicles/new" element={<NewVehicle />} />
            )}
            {affreightmentsVehiclesPermissions.alterar && (
              <Route path="/vehicles/:vehicleId" element={<EditVehicle />} />
            )}
          </>
        )}

        {(affreightmentsPassengersPermissions && affreightmentsPassengersPermissions.vizualizar && hasAffreightmentsAccessControlService) && (
          <Route path="/passengers" element={<Passengers />} />
        )}

        {(routingPermissions && routingPermissions.vizualizar && hasSomeRoutingService) && (
          <>
            {routingPermissions.incluir && (
              <Route path="/consults/new" element={<NewConsult />} />
            )}
            <Route path="/consults/search" element={<SearchConsult />} />
            <Route path="/consults/result/:consultCode" element={<ConsultResult />} />
          </>
        )}

        {(routingFilePermissions && routingFilePermissions.vizualizar && routingFilePermissions.incluir) && (
          <Route path="/consults/file" element={<ImportConsults />} />
        )}

        {reclamationsPermissions && reclamationsPermissions.vizualizar && (
          <Route path="/periodReclamations" element={<ReclamationsAtPeriod />} />
        )}

        {affreightmentsDashboardPermissions && affreightmentsDashboardPermissions.vizualizar && hasAffreightmentsAccessControlService && (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/lineMap" element={<LineMap />} />
          </>
        )}

        {(triangulationPermissions && triangulationPermissions.vizualizar && hasTriangulationService) && (
          <Route path="/triangulation" element={<Triangulation />} />
        )}

        {/* {(autImplantationPermissions && autImplantationPermissions.vizualizar && hasAutImplantationService) && (
          <Route path="/autImplantation" element={<AutImplantation />} />
        )} */}

        <Route path="/itens-relations" element={<ItensRelations />} />
        {/* <Route path="/importVtRegistrationData" element={<ImportVtRegistrationData />} /> */}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}
